import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getPoolV4Contract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import { poolid, uniswapev4Contract } from "../../utils/Enviroment";

const SqurtPriceV4 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  //   const contractAddress = pool;
  const SqurtPriceHoodV4 = useCallback(async () => {
    const contract = getPoolV4Contract(uniswapev4Contract, web3);
    if (!contract) {
      console.error("Contract not initialized properly.");
      return;
    }
    try {
      const SqurtPrice = await contract?.methods?.getSlot0(poolid)?.call();
      console.log(SqurtPrice, "err in pool ");
      return SqurtPrice.sqrtPriceX96;
    } catch (error) {
      console.error("Error fetching balance:", error.message || error);
      throw error;
    }
  }, [account]);
  return { SqurtPriceHoodV4 };
};

export default SqurtPriceV4;
